<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="d-flex align-center justify-space-between">
        <div class="flex-center">
          <div>เลขที่</div>
          <TextField
              theme="2"
              readonly
              hide-details
          ></TextField>
        </div>

        <div class="theme-color-one txt-head">
          15/11/2022
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 1 :</span> ข้อมูลทั่วไป <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
        </div>

        <!-- Form 1 -->
        <div>
          <!-- Form 1 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex xs4">
              <div class="mb-1 black--text">คำนำหน้า</div>
              <AutoBox
                  theme="3"
                  :items="masterData.title"
                  item-text="name"
                  item-value="name"
                  :value="form.p1_title_name"
                  @onChange="setFormField('p1_title_name', $event)"
              ></AutoBox>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">ชื่อ</div>
              <TextField
                  theme="3"
                  :value="form.p1_first_name"
                  @onChange="setFormField('p1_first_name', $event)"
              ></TextField>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">นามสกุล</div>
              <TextField
                  theme="3"
                  :value="form.p1_last_name"
                  @onChange="setFormField('p1_last_name', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex xs4">
              <div class="mb-1 black--text">อายุ (ปี)</div>
              <TextField
                  theme="3"
                  input-type="number"
                  :value="form.p1_age"
                  @onChange="setFormField('p1_age', $event)"
              ></TextField>
            </div>

            <div class="flex xs8">
              <div class="mb-1 black--text">หมายเลขบัตรประชาชน</div>
              <TextField
                  theme="3"
                  input-type="number"
                  max-length="13"
                  :value="form.p1_pid"
                  @onChange="setFormField('p1_pid', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex xs12">
              <div class="mb-1 black--text">ที่อยู่/อาคาร/หมู่บ้าน</div>
              <TextField
                  theme="3"
                  :value="form.p1_addr"
                  @onChange="setFormField('p1_addr', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex xs4">
              <div class="mb-1 black--text">จังหวัด</div>
              <AutoBox
                  theme="3"
                  :items="masterData.provinces"
                  item-text="name"
                  item-value="name"
                  :value="form.p1_addr_pid"
                  @onChange="setFormField('p1_addr_pid', $event)"
              ></AutoBox>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">เขต/อำเภอ</div>
              <AutoBox
                  theme="3"
                  :items="filteredDistricts"
                  item-text="name"
                  item-value="name"
                  :value="form.p1_addr_did"
                  @onChange="setFormField('p1_addr_did', $event)"
              ></AutoBox>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">แขวง/ตำบล</div>
              <AutoBox
                  theme="3"
                  :items="filteredSubdistricts"
                  item-text="name"
                  item-value="name"
                  :value="form.p1_addr_sdid"
                  @onChange="setFormField('p1_addr_sdid', $event)"
              ></AutoBox>
            </div>
          </div>

          <!-- Form 1 #line5 -->
          <div class="flex-center gap-16">
            <div class="flex xs4">
              <div class="mb-1 black--text">รหัสไปรษณีย์</div>
              <AutoBox
                  theme="3"
                  :value="form.p1_addr_postcode"
                  @onChange="setFormField('p1_addr_postcode', $event)"
              ></AutoBox>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">โทรศัพท์</div>
              <TextField
                  theme="3"
                  :value="form.p1_phone"
                  @onChange="setFormField('p1_phone', $event)"
              ></TextField>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">โทรศัพท์มือถือ</div>
              <TextField
                  theme="3"
                  input-type="number"
                  max-length="10"
                  :value="form.p1_mobile_phone"
                  @onChange="setFormField('p1_mobile_phone', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line6 -->
          <div class="flex-center gap-16">
            <div class="flex xs4">
              <div class="mb-1 black--text">โทรสาร</div>
              <TextField
                  theme="3"
                  :value="form.p1_fax"
                  @onChange="setFormField('p1_fax', $event)"
              ></TextField>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">อีเมล</div>
              <TextField
                  theme="3"
                  :value="form.p1_email"
                  @onChange="setFormField('p1_email', $event)"
              ></TextField>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">เว็บไซต์</div>
              <TextField
                  theme="3"
                  :value="form.p1_website"
                  @onChange="setFormField('p1_website', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line7 -->
          <div class="d-flex align-center gap-16">
            <div class="flex xs4">
              <div class="mb-1 black--text">ตำแหน่งในองค์กร</div>
              <TextField
                  theme="3"
                  :value="form.p1_position"
                  @onChange="setFormField('p1_position', $event)"
              ></TextField>
            </div>

            <div class="flex shrink flex-center gap-12">
              <div class="mb-1 black--text">อำนาจในการตัดสินใจเข้าร่วมโครงการ</div>
              <SwitchInset
                  :input-value="form.p1_authority"
                  @onChange="setFormField('p1_authority', $event)"
              ></SwitchInset>
              <div>ไม่มี</div>
            </div>
          </div>

        </div>

      </div>

      <div class="card-part">
        <div class="d-flex align-center gap-12">
          <div class="mb-1 txt-head black--text">ข้อมูลสถานประกอบการ</div>
          <SwitchInset
              :input-value="form.p1_same_addr"
              @onChange="setFormField('p1_same_addr', $event)"
          ></SwitchInset>
          <div>ตั้งอยู่ที่เดียวกัน</div>
        </div>

        <!-- Form 2 -->
        <div v-if="!form.p1_same_addr">
          <!-- Form 2 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex xs12">
              <div class="mb-1 black--text">ที่อยู่/อาคาร/หมู่บ้าน</div>
              <TextField
                  theme="3"
                  :value="form.p1_org_addr"
                  @onChange="setFormField('p1_org_addr', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 2 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex xs4">
              <div class="mb-1 black--text">จังหวัด</div>
              <AutoBox
                  theme="3"
                  :items="masterData.provinces"
                  item-text="name"
                  item-value="name"
                  :value="form.p1_org_pid"
                  @onChange="setFormField('p1_org_pid', $event)"
              ></AutoBox>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">เขต/อำเภอ</div>
              <AutoBox
                  theme="3"
                  :items="filteredOrgDistricts"
                  item-text="name"
                  item-value="name"
                  :value="form.p1_org_did"
                  @onChange="setFormField('p1_org_did', $event)"
              ></AutoBox>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">แขวง/ตำบล</div>
              <AutoBox
                  theme="3"
                  :items="filteredOrgSubdistricts"
                  item-text="name"
                  item-value="name"
                  :value="form.p1_org_sdid"
                  @onChange="setFormField('p1_org_sdid', $event)"
              ></AutoBox>
            </div>
          </div>

          <!-- Form 2 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex xs4">
              <div class="mb-1 black--text">รหัสไปรษณีย์</div>
              <AutoBox
                  theme="3"
                  :value="form.p1_org_postcode"
                  @onChange="setFormField('p1_org_postcode', $event)"
              ></AutoBox>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">โทรศัพท์</div>
              <TextField
                  theme="3"
                  :value="form.p1_org_phone"
                  @onChange="setFormField('p1_org_phone', $event)"
              ></TextField>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">โทรศัพท์มือถือ</div>
              <TextField
                  theme="3"
                  input-type="number"
                  max-length="10"
                  :value="form.p1_org_mobile_phone"
                  @onChange="setFormField('p1_org_mobile_phone', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 2 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex xs4">
              <div class="mb-1 black--text">โทรสาร</div>
              <TextField
                  theme="3"
                  :value="form.p1_org_fax"
                  @onChange="setFormField('p1_org_fax', $event)"
              ></TextField>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">อีเมล</div>
              <TextField
                  theme="3"
                  :value="form.p1_org_email"
                  @onChange="setFormField('p1_org_email', $event)"
              ></TextField>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">เว็บไซต์</div>
              <TextField
                  theme="3"
                  :value="form.p1_org_website"
                  @onChange="setFormField('p1_org_website', $event)"
              ></TextField>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="txt-head black--text mb-3">
          สถานะ <span class="txt-normal theme-color-eight">(สามารถระบุได้หลายข้อ)</span>
        </div>
        <!-- Form 3 -->
        <div>
          <!-- Form 3 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <AutoBox
                  theme="3"
                  multiple
                  chips
                  deletable-chips
                  :items="masterData.personal_status"
                  item-text="name"
                  item-value="name"
                  :value="form.p1_personal_status"
                  @onChange="setFormField('p1_personal_status', $event)"
              ></AutoBox>
            </div>
          </div>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import SwitchInset from "../../components/input/SwitchInset"
import AutoBox from "../../components/input/AutoBox"
import { eventBus } from "../../plugins/global-funcs"
import { mapState } from "vuex"

export default {
  name: "FormGeneral",
  components: {
    TextField,
    SwitchInset,
    AutoBox
  },
  props: {
    masterData: Object,
    formData: Object
  },
  data () {
    return {
      form: {},
      filteredDistricts: [],
      filteredSubdistricts: [],
      filteredOrgDistricts: [],
      filteredOrgSubdistricts: [],
    }
  },
  watch: {
    formData: {
      handler(newValue) {
        this.form = JSON.parse(JSON.stringify(newValue));
        this.form.p1_personal_status = Array.isArray(this.form.p1_personal_status) ? this.form.p1_personal_status : [this.form.p1_personal_status]

        if (this.form.p1_addr_pid) {
          const province_id = parseInt(this.masterData.provinces.find(province => province.name === this.form.p1_addr_pid).province_id)
          this.filteredDistricts = this.masterData.districts.filter(district => district.province_id === province_id)
        }

        if (this.form.p1_addr_did) {
          const district_id = parseInt(this.masterData.districts.find(district => district.name === this.form.p1_addr_did).district_id)
          this.filteredSubdistricts = this.masterData.subdistricts.filter(subdistrict => subdistrict.district_id === district_id)
        }

        if (this.form.p1_org_pid) {
          const province_id = parseInt(this.masterData.provinces.find(province => province.name === this.form.p1_org_pid).province_id)
          this.filteredOrgDistricts = this.masterData.districts.filter(district => district.province_id === province_id)
        }

        if (this.form.p1_org_did) {
          const district_id = parseInt(this.masterData.districts.find(district => district.name === this.form.p1_org_did).district_id)
          this.filteredOrgSubdistricts = this.masterData.subdistricts.filter(subdistrict => subdistrict.district_id === district_id)
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState({
      GeneralForm: state => state.Requirement.GeneralForm
    })
  },
  created () {
    this.form = JSON.parse(JSON.stringify(this.formData))
    eventBus.$on('requirementFormGeneral', () => {
      eventBus.$emit('requirementFormGeneralSend', this.form)
    })
    eventBus.$emit('requirementFormGeneralSend', this.form)
  },
  methods: {
    setFormField (field, val) {
      if (Array.isArray(this.form[field])) {
        this.form[field] = val;
      } else {
        this.form[field] = [val];
      }
      this.$forceUpdate();

      if (field === 'p1_addr_pid') {
        console.log('p1_addr_pid changed')
        //get province_id from masterdata
        const province_id = parseInt(this.masterData.provinces.find(province => province.name === val).province_id)
        this.filteredDistricts = this.masterData.districts.filter(district => district.province_id === province_id)
      }

      if (field === 'p1_addr_did') {
        //get district_id from masterdata
        const district_id = parseInt(this.masterData.districts.find(district => district.name === val).district_id)
        this.filteredSubdistricts = this.masterData.subdistricts.filter(subdistrict => subdistrict.district_id === district_id)
      }

      if (field === 'p1_org_pid') {
        //get province_id from masterdata
        const province_id = parseInt(this.masterData.provinces.find(province => province.name === val).province_id)
        this.filteredOrgDistricts = this.masterData.districts.filter(district => district.province_id === province_id)
      }

      if (field === 'p1_org_did') {
        //get district_id from masterdata
        const district_id = parseInt(this.masterData.districts.find(district => district.name === val).district_id)
        this.filteredOrgSubdistricts = this.masterData.subdistricts.filter(subdistrict => subdistrict.district_id === district_id)
      }
    }
  }
}
</script>

<style scoped>

</style>